module.exports = __webpack_public_path__ + "images/david-bg-test2.jpg";